export var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode["UNKNOWN"] = "UNKNOWN";
    ApiErrorCode["INTERNAL"] = "INTERNAL";
    ApiErrorCode["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    ApiErrorCode["ORG_RESTRICTED"] = "ORG_RESTRICTED";
    ApiErrorCode["PROJECT_NOT_FOUND"] = "PROJECT_NOT_FOUND";
    ApiErrorCode["PROJECT_LABEL_NOT_FOUND"] = "PROJECT_LABEL_NOT_FOUND";
    ApiErrorCode["PROJECT_LABEL_ALREADY_EXISTS"] = "PROJECT_LABEL_ALREADY_EXISTS";
    ApiErrorCode["PROJECT_LABEL_NAME_ARCHIVED"] = "PROJECT_LABEL_NAME_ARCHIVED";
    ApiErrorCode["LOCAL_CAMERA_ACCESS_NOT_ENABLED"] = "LOCAL_CAMERA_ACCESS_NOT_ENABLED";
    ApiErrorCode["PENDING_TASK_NOT_FOUND"] = "PENDING_TASK_NOT_FOUND";
    ApiErrorCode["OBJECT_PATH_INVALID"] = "OBJECT_PATH_INVALID";
    ApiErrorCode["STORAGE_OBJECT_NOT_FOUND"] = "STORAGE_OBJECT_NOT_FOUND";
    ApiErrorCode["EVENT_ALREADY_SAVED"] = "EVENT_ALREADY_SAVED";
    ApiErrorCode["TASK_IMPORT_SAME_PROJECT"] = "TASK_IMPORT_SAME_PROJECT";
    ApiErrorCode["ANNOTATION_GROUP_LABEL_MISMATCH"] = "ANNOTATION_GROUP_LABEL_MISMATCH";
    ApiErrorCode["TRAINING_LIMIT_REACHED"] = "TRAINING_LIMIT_REACHED";
    ApiErrorCode["MODEL_NOT_FOUND"] = "MODEL_NOT_FOUND";
    ApiErrorCode["MODEL_LABEL_ARCHIVED"] = "MODEL_LABEL_ARCHIVED";
    ApiErrorCode["MODEL_NOT_EDITABLE"] = "MODEL_NOT_EDITABLE";
    ApiErrorCode["MODEL_NOT_DRAFT"] = "MODEL_NOT_DRAFT";
    ApiErrorCode["MODEL_NOT_TRAINING"] = "MODEL_NOT_TRAINING";
    ApiErrorCode["MODEL_BATCH_JOB_MISSING"] = "MODEL_BATCH_JOB_MISSING";
    ApiErrorCode["DATASET_HAS_NO_LABELED_IMAGES"] = "DATASET_HAS_NO_LABELED_IMAGES";
    ApiErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ApiErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ApiErrorCode["ORGANIZATION_NOT_FOUND"] = "ORGANIZATION_NOT_FOUND";
    ApiErrorCode["ORGANIZATION_MEMBERSHIP_REQUIRED"] = "ORGANIZATION_MEMBERSHIP_REQUIRED";
    ApiErrorCode["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
    ApiErrorCode["REFRESH_TOKEN_MISSING"] = "REFRESH_TOKEN_MISSING";
    ApiErrorCode["REFRESH_TOKEN_INVALID"] = "REFRESH_TOKEN_INVALID";
    ApiErrorCode["USER_EMAIL_ALREADY_EXISTS"] = "USER_EMAIL_ALREADY_EXISTS";
    ApiErrorCode["EMAIL_VERIFICATION_TOKEN_INVALID"] = "EMAIL_VERIFICATION_TOKEN_INVALID";
    ApiErrorCode["PASSWORD_RESET_TOKEN_INVALID"] = "PASSWORD_RESET_TOKEN_INVALID";
    ApiErrorCode["PASSWORD_CURRENT_INCORRECT"] = "PASSWORD_CURRENT_INCORRECT";
    ApiErrorCode["PASSWORD_UNCHANGED"] = "PASSWORD_UNCHANGED";
    ApiErrorCode["ROLE_INSUFFICIENT"] = "ROLE_INSUFFICIENT";
    ApiErrorCode["ROLE_ADMIN_REQUIRED"] = "ROLE_ADMIN_REQUIRED";
    ApiErrorCode["ROLE_SUPER_ADMIN_REQUIRED"] = "ROLE_SUPER_ADMIN_REQUIRED";
    ApiErrorCode["SUPER_ADMIN_SESSION_READ_ONLY"] = "SUPER_ADMIN_SESSION_READ_ONLY";
    ApiErrorCode["INVITATION_INVALID"] = "INVITATION_INVALID";
    ApiErrorCode["INVITATION_ALREADY_MEMBER"] = "INVITATION_ALREADY_MEMBER";
    ApiErrorCode["INVITATION_NOT_FOUND"] = "INVITATION_NOT_FOUND";
    ApiErrorCode["INVITATION_NOT_PENDING"] = "INVITATION_NOT_PENDING";
    ApiErrorCode["INVITATION_ALREADY_SENT"] = "INVITATION_ALREADY_SENT";
    ApiErrorCode["ORGANIZATION_MEMBER_ALREADY_EXISTS"] = "ORGANIZATION_MEMBER_ALREADY_EXISTS";
    ApiErrorCode["MEMBER_NOT_FOUND"] = "MEMBER_NOT_FOUND";
    ApiErrorCode["ORGANIZATION_OWNER_CANNOT_BE_REMOVED"] = "ORGANIZATION_OWNER_CANNOT_BE_REMOVED";
    ApiErrorCode["ADMIN_REMOVAL_OWNER_ONLY"] = "ADMIN_REMOVAL_OWNER_ONLY";
    ApiErrorCode["ORGANIZATION_OWNER_ROLE_CANNOT_CHANGE"] = "ORGANIZATION_OWNER_ROLE_CANNOT_CHANGE";
    ApiErrorCode["MODEL_NOT_DONE"] = "MODEL_NOT_DONE";
    ApiErrorCode["MODEL_LABELS_MISSING"] = "MODEL_LABELS_MISSING";
    ApiErrorCode["MODEL_CLASSIFICATION_UNSUPPORTED"] = "MODEL_CLASSIFICATION_UNSUPPORTED";
    ApiErrorCode["MODEL_TYPE_MISMATCH"] = "MODEL_TYPE_MISMATCH";
    ApiErrorCode["MODEL_RAW_OUTPUT_MISSING"] = "MODEL_RAW_OUTPUT_MISSING";
    ApiErrorCode["MODEL_BACKEND_NOT_INFERABLE"] = "MODEL_BACKEND_NOT_INFERABLE";
    ApiErrorCode["SAM3_PROMPTS_EMPTY"] = "SAM3_PROMPTS_EMPTY";
    ApiErrorCode["SAM3_PROMPT_LABELS_FOREIGN"] = "SAM3_PROMPT_LABELS_FOREIGN";
    ApiErrorCode["SAM3_PROMPTS_TOO_MANY"] = "SAM3_PROMPTS_TOO_MANY";
    ApiErrorCode["TASK_ALREADY_ANNOTATED"] = "TASK_ALREADY_ANNOTATED";
    ApiErrorCode["PREDICT_PROVIDER_WRONG_ROUTE"] = "PREDICT_PROVIDER_WRONG_ROUTE";
    ApiErrorCode["ML_INFER_NOT_CONFIGURED"] = "ML_INFER_NOT_CONFIGURED";
    ApiErrorCode["PREDICT_MODEL_REQUIRED"] = "PREDICT_MODEL_REQUIRED";
    ApiErrorCode["PREDICT_MODEL_TYPE_UNSUPPORTED"] = "PREDICT_MODEL_TYPE_UNSUPPORTED";
    ApiErrorCode["STORAGE_READ_FAILED"] = "STORAGE_READ_FAILED";
    ApiErrorCode["SAM3_NOT_CONFIGURED"] = "SAM3_NOT_CONFIGURED";
    ApiErrorCode["SAM3_UNAVAILABLE"] = "SAM3_UNAVAILABLE";
    ApiErrorCode["SAM3_NOT_IMPLEMENTED"] = "SAM3_NOT_IMPLEMENTED";
    ApiErrorCode["SAM3_FAILED"] = "SAM3_FAILED";
    ApiErrorCode["SAM3_REJECTED"] = "SAM3_REJECTED";
    ApiErrorCode["VISION_NOTE_NOT_FOUND"] = "VISION_NOTE_NOT_FOUND";
    ApiErrorCode["VISION_TURN_NOT_FOUND"] = "VISION_TURN_NOT_FOUND";
    ApiErrorCode["VISION_NOT_CONFIGURED"] = "VISION_NOT_CONFIGURED";
    ApiErrorCode["LABEL_NOT_FOUND"] = "LABEL_NOT_FOUND";
    ApiErrorCode["VISION_PROVIDER_TIMEOUT"] = "VISION_PROVIDER_TIMEOUT";
    ApiErrorCode["VISION_PROVIDER_FAILED"] = "VISION_PROVIDER_FAILED";
    ApiErrorCode["VISION_RESPONSE_UNREADABLE"] = "VISION_RESPONSE_UNREADABLE";
    ApiErrorCode["VISION_RESPONSE_TRUNCATED"] = "VISION_RESPONSE_TRUNCATED";
    ApiErrorCode["VISION_SEGMENTATION_UNSUPPORTED"] = "VISION_SEGMENTATION_UNSUPPORTED";
    ApiErrorCode["TASK_IMAGE_MISSING"] = "TASK_IMAGE_MISSING";
    ApiErrorCode["VISION_CONVERSATION_CLOSED"] = "VISION_CONVERSATION_CLOSED";
    ApiErrorCode["VISION_CONVERSATION_PROVIDER_MISMATCH"] = "VISION_CONVERSATION_PROVIDER_MISMATCH";
    ApiErrorCode["VISION_CONVERSATION_NO_TURN"] = "VISION_CONVERSATION_NO_TURN";
    ApiErrorCode["VISION_CONVERSATION_BUSY"] = "VISION_CONVERSATION_BUSY";
    ApiErrorCode["VISION_CONVERSATION_NOT_FOUND"] = "VISION_CONVERSATION_NOT_FOUND";
    ApiErrorCode["PRE_ANNOTATE_MODEL_TYPE_INVALID"] = "PRE_ANNOTATE_MODEL_TYPE_INVALID";
    ApiErrorCode["PRE_ANNOTATE_MODEL_TYPE_MISMATCH"] = "PRE_ANNOTATE_MODEL_TYPE_MISMATCH";
    ApiErrorCode["LABEL_NOT_IN_PROJECT"] = "LABEL_NOT_IN_PROJECT";
    ApiErrorCode["VISION_LABEL_DESCRIPTION_REQUIRED"] = "VISION_LABEL_DESCRIPTION_REQUIRED";
    ApiErrorCode["VISION_LABELS_REQUIRED"] = "VISION_LABELS_REQUIRED";
    ApiErrorCode["PRE_ANNOTATE_SETTINGS_MODEL_UNUSABLE"] = "PRE_ANNOTATE_SETTINGS_MODEL_UNUSABLE";
    ApiErrorCode["TASK_NOT_FOUND"] = "TASK_NOT_FOUND";
    ApiErrorCode["REFERENCE_TASK_NOT_ANNOTATED"] = "REFERENCE_TASK_NOT_ANNOTATED";
    ApiErrorCode["AUTO_ANNOTATE_BATCH_TASK_CLAIMED"] = "AUTO_ANNOTATE_BATCH_TASK_CLAIMED";
    ApiErrorCode["AUTO_ANNOTATE_BATCH_ALREADY_RUNNING"] = "AUTO_ANNOTATE_BATCH_ALREADY_RUNNING";
    ApiErrorCode["VISION_NOT_AVAILABLE"] = "VISION_NOT_AVAILABLE";
    ApiErrorCode["AUTO_ANNOTATE_BATCH_NOTHING_TO_DO"] = "AUTO_ANNOTATE_BATCH_NOTHING_TO_DO";
    ApiErrorCode["CONVERSION_MODEL_NOT_DONE"] = "CONVERSION_MODEL_NOT_DONE";
    ApiErrorCode["CONVERSION_RAW_OUTPUT_MISSING"] = "CONVERSION_RAW_OUTPUT_MISSING";
    ApiErrorCode["MODEL_NOT_RECONVERTIBLE"] = "MODEL_NOT_RECONVERTIBLE";
    ApiErrorCode["CONVERSION_TARGET_INVALID"] = "CONVERSION_TARGET_INVALID";
    ApiErrorCode["CONVERSION_TARGET_UNSUPPORTED"] = "CONVERSION_TARGET_UNSUPPORTED";
    ApiErrorCode["CONVERSION_CALIBRATION_MISSING"] = "CONVERSION_CALIBRATION_MISSING";
    ApiErrorCode["CONVERSION_IN_FLIGHT"] = "CONVERSION_IN_FLIGHT";
    ApiErrorCode["CONVERSION_ALREADY_FINISHED"] = "CONVERSION_ALREADY_FINISHED";
    ApiErrorCode["CONVERSION_ARTIFACT_MISSING"] = "CONVERSION_ARTIFACT_MISSING";
    ApiErrorCode["CONVERSION_NOT_FOUND"] = "CONVERSION_NOT_FOUND";
    ApiErrorCode["CONVERSION_BACKEND_NOT_CONFIGURED"] = "CONVERSION_BACKEND_NOT_CONFIGURED";
    ApiErrorCode["CONVERSION_FAILED"] = "CONVERSION_FAILED";
    ApiErrorCode["CONVERSION_DISPATCH_FAILED"] = "CONVERSION_DISPATCH_FAILED";
    ApiErrorCode["CONVERSION_DEADLINE_EXCEEDED"] = "CONVERSION_DEADLINE_EXCEEDED";
    ApiErrorCode["CONVERSION_EXECUTION_CANCELLED"] = "CONVERSION_EXECUTION_CANCELLED";
    ApiErrorCode["CONVERSION_JOB_FAILED_SILENTLY"] = "CONVERSION_JOB_FAILED_SILENTLY";
    ApiErrorCode["CONVERSION_NO_ARTIFACT"] = "CONVERSION_NO_ARTIFACT";
    ApiErrorCode["TRAINING_PAYLOAD_RAW_OUTPUT_MISSING"] = "TRAINING_PAYLOAD_RAW_OUTPUT_MISSING";
    ApiErrorCode["MODEL_BACKEND_NOT_TRAINABLE"] = "MODEL_BACKEND_NOT_TRAINABLE";
    ApiErrorCode["TRAINING_BACKEND_NOT_CONFIGURED"] = "TRAINING_BACKEND_NOT_CONFIGURED";
    ApiErrorCode["TRAINING_FAILED"] = "TRAINING_FAILED";
    ApiErrorCode["TRAINING_DISPATCH_FAILED"] = "TRAINING_DISPATCH_FAILED";
    ApiErrorCode["CONFIDENCE_REPORT_NOT_FOUND"] = "CONFIDENCE_REPORT_NOT_FOUND";
    ApiErrorCode["CONFIDENCE_REPORT_ALREADY_RUNNING"] = "CONFIDENCE_REPORT_ALREADY_RUNNING";
    ApiErrorCode["CONFIDENCE_REPORT_BACKEND_NOT_CONFIGURED"] = "CONFIDENCE_REPORT_BACKEND_NOT_CONFIGURED";
    ApiErrorCode["PROJECT_HAS_NO_TASKS"] = "PROJECT_HAS_NO_TASKS";
    ApiErrorCode["CONFIDENCE_REPORT_NOT_CANCELLABLE"] = "CONFIDENCE_REPORT_NOT_CANCELLABLE";
    ApiErrorCode["CONFIDENCE_REPORT_FAILED"] = "CONFIDENCE_REPORT_FAILED";
    ApiErrorCode["CONFIDENCE_REPORT_DISPATCH_FAILED"] = "CONFIDENCE_REPORT_DISPATCH_FAILED";
    ApiErrorCode["DASHBOARD_CONFIGURATION_NOT_FOUND"] = "DASHBOARD_CONFIGURATION_NOT_FOUND";
    ApiErrorCode["EVAL_THRESHOLD_NOT_FOUND"] = "EVAL_THRESHOLD_NOT_FOUND";
    ApiErrorCode["EVAL_THRESHOLD_VALUE_OUT_OF_RANGE"] = "EVAL_THRESHOLD_VALUE_OUT_OF_RANGE";
    ApiErrorCode["EVAL_THRESHOLD_VALUE_ALREADY_EXISTS"] = "EVAL_THRESHOLD_VALUE_ALREADY_EXISTS";
    ApiErrorCode["EVAL_THRESHOLD_LAST_VALUE_LOCKED"] = "EVAL_THRESHOLD_LAST_VALUE_LOCKED";
    ApiErrorCode["EVAL_THRESHOLD_LAST_CANNOT_DELETE"] = "EVAL_THRESHOLD_LAST_CANNOT_DELETE";
    ApiErrorCode["TARGET_LABEL_NOT_FOUND"] = "TARGET_LABEL_NOT_FOUND";
    ApiErrorCode["TARGET_PARENT_LABEL_NOT_FOUND"] = "TARGET_PARENT_LABEL_NOT_FOUND";
    ApiErrorCode["HYPERPARAM_SUGGESTION_NOT_CONFIGURED"] = "HYPERPARAM_SUGGESTION_NOT_CONFIGURED";
    ApiErrorCode["HYPERPARAM_SUGGESTION_BACKEND_UNSUPPORTED"] = "HYPERPARAM_SUGGESTION_BACKEND_UNSUPPORTED";
    ApiErrorCode["HYPERPARAM_SUGGESTION_TIMEOUT"] = "HYPERPARAM_SUGGESTION_TIMEOUT";
    ApiErrorCode["HYPERPARAM_SUGGESTION_FAILED"] = "HYPERPARAM_SUGGESTION_FAILED";
    ApiErrorCode["HYPERPARAM_SUGGESTION_RESPONSE_INVALID"] = "HYPERPARAM_SUGGESTION_RESPONSE_INVALID";
    ApiErrorCode["DEVICE_REVOKED"] = "DEVICE_REVOKED";
    ApiErrorCode["DEVICE_ALREADY_ASSIGNED"] = "DEVICE_ALREADY_ASSIGNED";
    ApiErrorCode["DEVICE_NOT_ASSIGNED"] = "DEVICE_NOT_ASSIGNED";
    ApiErrorCode["MODEL_OUTPUT_NOT_FOUND"] = "MODEL_OUTPUT_NOT_FOUND";
    ApiErrorCode["DEVICE_NOT_FOUND"] = "DEVICE_NOT_FOUND";
    ApiErrorCode["DEVICE_ASSIGNED_ELSEWHERE"] = "DEVICE_ASSIGNED_ELSEWHERE";
    ApiErrorCode["RELAY_NOT_CONFIGURED"] = "RELAY_NOT_CONFIGURED";
    ApiErrorCode["TURN_NOT_CONFIGURED"] = "TURN_NOT_CONFIGURED";
    ApiErrorCode["DEVICE_ASSERTION_MISSING"] = "DEVICE_ASSERTION_MISSING";
    ApiErrorCode["DEVICE_ASSERTION_MALFORMED"] = "DEVICE_ASSERTION_MALFORMED";
    ApiErrorCode["DEVICE_UNKNOWN"] = "DEVICE_UNKNOWN";
    ApiErrorCode["DEVICE_ASSERTION_INVALID"] = "DEVICE_ASSERTION_INVALID";
    ApiErrorCode["DEVICE_ASSERTION_REPLAYED"] = "DEVICE_ASSERTION_REPLAYED";
    ApiErrorCode["DATABASE_UNAVAILABLE"] = "DATABASE_UNAVAILABLE";
    ApiErrorCode["EVAL_TEST_CASE_NOT_FOUND"] = "EVAL_TEST_CASE_NOT_FOUND";
    ApiErrorCode["EVAL_LIMIT_NOT_FOUND"] = "EVAL_LIMIT_NOT_FOUND";
    ApiErrorCode["CAPTURED_VIDEO_NOT_FOUND"] = "CAPTURED_VIDEO_NOT_FOUND";
})(ApiErrorCode || (ApiErrorCode = {}));
//# sourceMappingURL=error-code.js.map